import React from 'react'
import { ButtonDep as Button } from '..'

const Page404: React.FC<{}> = () => {
  return (
    <div className='page-not-found'>
      <h1>404</h1>
      <p className='page-not-found__larger-text'>Sorry! We couldn't find the page you were looking for.</p>
      <ul>
        <li>The page you tried to open might have been moved.</li>
        <li>The page could no longer be available.</li>
        <li>The URL might be spelled incorrectly.</li>
      </ul>
      <a href='/'>
        <Button type='primary' className='mt-3 mb-3' label='Go to front page' aria-label='Front page' />
      </a>
    </div>
  )
}

export default Page404
